import { render, staticRenderFns } from "./TokensTable.vue?vue&type=template&id=6d387761&scoped=true&"
import script from "./TokensTable.vue?vue&type=script&lang=js&"
export * from "./TokensTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d387761",
  null
  
)

export default component.exports